import * as React from 'react'

export const Shield = () => (
  <svg
    width="70"
    height="70"
    viewBox="0 0 70 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M35 70C25.9749 64.8479 4.23828 49.3158 4.23828 18.3531V8.35352H6.28906C11.0295 8.54178 22.507 8.33123 33.8625 0.759063L35 0L36.1375 0.759063C47.5069 8.3393 59.0125 8.52182 63.4025 8.36158L65.7617 8.33984V18.3531C65.7617 54.9094 35.4115 69.5893 35 70Z"
      fill="#BBDADD"
    />
    <path
      d="M65.7617 18.3531V8.33984L63.4025 8.36158C59.0126 8.52182 47.5069 8.3393 36.1375 0.759063L35 0V70C35.4115 69.5892 65.7617 54.9091 65.7617 18.3531Z"
      fill="#B3D2D5"
    />
    <path
      d="M35 60.6189C34.6422 60.2088 12.4414 46.9588 12.4414 18.3536V16.5251L14.2579 16.1926C21.2112 15.3895 27.8623 13.2947 34.0246 9.96219L35 9.43555L35.9754 9.96232C42.1377 13.2948 48.7888 15.3896 55.7421 16.1927L57.5586 16.4011V18.2296C57.5586 46.2841 35.3757 60.1883 35 60.6189Z"
      fill="#DFFCFF"
    />
    <path
      d="M57.5586 18.2296V16.4011L55.7421 16.1929C48.7888 15.3898 42.1377 13.295 35.9754 9.96246L35 9.43555V60.6189C35.3757 60.1881 57.5586 46.2841 57.5586 18.2296Z"
      fill="#D0EFF2"
    />
    <path
      d="M32.9492 42.0159L25.3469 34.4136L28.2467 31.5137L32.9492 36.216L43.804 25.3613L46.7038 28.2613L32.9492 42.0159Z"
      fill="#2D4C4F"
    />
    <path
      d="M35 39.9651L46.7038 28.2613L43.804 25.3613L35 34.1652V39.9651Z"
      fill="#233B3E"
    />
  </svg>
)
